let playerDisplayColors: { [key: string]: string } = {
  red: "#ff4038",
  blue: "#2799d8",
  green: "#57a141",
  yellow: "#ecce46",

  cyan: "#00a9a9",
  orange: "#ee6401",
  cerise: "#d8358c",
  lime: "#b3cc00",

  purple: "#825a9d",
  white: "#b1b1b1",
};

export function getCgoColor(inputColor: string) {
  return playerDisplayColors[inputColor] ?? inputColor;
}

export default playerDisplayColors;
